export default __webpack_public_path__ + "c03683306827fa170cee5c127d3c3f04.svg";